<div class="page-header">
  <div>
    <h1 class="page-title">Schedule Management</h1>
    <p class="page-subtitle">Manage content schedules for your displays</p>
  </div>
  <div class="page-header-actions">
    <button class="btn btn-primary">+ Create Schedule</button>
  </div>
</div>

<div class="data-card">
  <div class="data-card-header">
    <div>
      <span class="data-card-title">All Schedules</span>
      <span class="data-count">{{ rows.length }} total</span>
    </div>
    <div class="data-card-meta">
      <input type="text" placeholder="Search schedules..." style="width:220px">
    </div>
  </div>

  <table>
    <thead>
      <tr>
        <th>#</th>
        <th>Schedule Name</th>
        <th>Display</th>
        <th>Start Date</th>
        <th>End Date</th>
        <th>Frequency</th>
        <th>Status</th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of rows">
        <td>{{ row.id }}</td>
        <td>{{ row.name }}</td>
        <td>{{ row.display }}</td>
        <td>{{ row.start }}</td>
        <td>{{ row.end }}</td>
        <td>{{ row.frequency }}</td>
        <td><span class="status-badge status-badge--{{ row.status }}">{{ row.status }}</span></td>
        <td>
          <div class="action-btns">
            <button class="btn-icon" title="Edit">
              <svg width="15" height="15" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
            </button>
            <button class="btn-icon btn-icon--danger" title="Delete">
              <svg width="15" height="15" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4h6v2"/></svg>
            </button>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>
